import Axios from "axios";
import Authorization from './auth';
import { executeCall } from "./utils";

const ai = (domain, _resource, withAuth = true) => {
    const url = `${domain}/ai`;
    const getHeaders = () => withAuth ? Authorization() : {};
    return {
        getFeatureStatus: () => executeCall(() =>
            Axios.get(`${url}/feature-status`, { headers: getHeaders() })
        ),
        getAnalysis: (noteId) => executeCall(() =>
            Axios.get(`${url}/sessions/${noteId}/analysis`, { headers: getHeaders() })
        ),
        triggerAnalysis: (noteId, force = false) => executeCall(() =>
            Axios.post(`${url}/sessions/${noteId}/analyze`, { force }, { headers: getHeaders() })
        ),
        getSummary: (clientId, params = {}) => executeCall(() =>
            Axios.get(`${url}/clients/${clientId}/summary`, { params, headers: getHeaders() })
        ),
    };
};

export default ai;
